// src/components/runs/RunsHeader.jsx
import React from 'react';
import { Search, Filter, CalendarDays } from 'lucide-react';
import { useTheme } from '../../theme/ThemeContext';

const RunsHeader = ({
  search,
  onSearchChange,
  dateFilter,
  onDateFilterChange,
  onAddClick,
}) => {
  const { theme } = useTheme();

  const applyInputFocusStyle = (e) => {
    e.target.style.borderColor = theme.primary[500];
    e.target.style.boxShadow = `0 0 0 3px ${theme.primary[500]}33`;
  };

  const resetInputFocusStyle = (e) => {
    e.target.style.borderColor = 'rgb(226 232 240)';
    e.target.style.boxShadow = 'none';
  };

  return (
    <div className="mb-8">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        {/* Left: title + subtitle */}
        <div>
          <h2 className="text-2xl font-bold text-slate-800">
            Schedule Runs
          </h2>
          <p className="mt-1 text-slate-600">
            Plan and manage guard patrol runs for each day.
          </p>
        </div>

        {/* Right: search, date filter, create button */}
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-end">
          {/* Search */}
          <div className="relative w-full sm:w-60">
            <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
            <input
              type="text"
              placeholder="Search runs by title, date, guard..."
              value={search}
              onChange={(e) => onSearchChange(e.target.value)}
              className="w-full rounded-xl border border-slate-200 bg-white py-2 pl-9 pr-3 text-sm focus:outline-none transition-all"
              style={{
                borderColor: 'rgb(226 232 240)',
              }}
              onFocus={applyInputFocusStyle}
              onBlur={resetInputFocusStyle}
            />
          </div>

          {/* Date filter + create button */}
          <div className="flex gap-2">
            {/* Date filter */}
            <div className="relative w-32">
              <CalendarDays className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
              <input
                type="date"
                value={dateFilter}
                onChange={(e) => onDateFilterChange(e.target.value)}
                className="w-full rounded-xl border border-slate-200 bg-white py-2 pl-9 pr-3 text-sm focus:outline-none transition-all"
                style={{
                  borderColor: 'rgb(226 232 240)',
                }}
                onFocus={applyInputFocusStyle}
                onBlur={resetInputFocusStyle}
              />
            </div>

            {/* (Optional) filter button – visual only, same as guards */}
            <button className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 transition-colors hover:bg-slate-50">
              <Filter className="h-5 w-5" />
            </button>

            {/* Create Run */}
            <button
              onClick={onAddClick}
              className="inline-flex flex-1 items-center justify-center gap-2 rounded-xl px-4 py-2 text-sm font-semibold text-white shadow-sm transition-all hover:shadow-lg sm:flex-none"
              style={{
                background: `linear-gradient(135deg, ${theme.primary[600]} 0%, ${theme.secondary[600]} 100%)`,
              }}
            >
              <CalendarDays className="h-4 w-4" />
              <span>Create Run</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RunsHeader;
